import bannerBgLq from "@circle-assets/images/opt-in/opt-in-banner-bg-lq.webp";
import bannerBg from "@circle-assets/images/opt-in/opt-in-banner-bg.webp";
import { Button as UIKitButton } from "@circle-react-shared/uikit/Button";
import { HelloBar } from "@circle-react-shared/uikit/HelloBar";
import { SanitizeHTMLString } from "@circle-react-shared/uikit/SanitizeContent";
import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circleco/compass/components/Icon";
import { useV4Rollback } from "react/components/NewVersionOptIn/OptInLandingPage/hooks/useV4Rollback";

import { t } from "@/i18n-js/instance";

import { useActivationConfirmationModal } from "../ActivationConfirmationModal";

export interface PreviewBarProps {
  previewBarCtaContent: string;
  previewBarText: string;
  showActivationButton: boolean;
}

export const PreviewBarComponent = ({
  previewBarCtaContent,
  previewBarText,
  showActivationButton,
}: PreviewBarProps) => {
  const { mutate: rollback, isPending: isRollingBackPending } = useV4Rollback();
  const activationConfirmationModal = useActivationConfirmationModal();
  const isDockExpanded = useCircleAIShellStore(s => s.dockMode === "expanded");

  return (
    <HelloBar
      className="relative bg-cover"
      style={{
        backgroundImage: `url(${bannerBg}), url(${bannerBgLq}), linear-gradient(to right, #1B2563 0%, #0A0B14 35%, #0A0B14 50%, #7B3030 72%, #BF6040 100%)`,
      }}
    >
      <div
        className={classNames(
          "absolute",
          isDockExpanded ? "left-[12px]" : "left-5", // To keep it exactly aligned with the left sidebar
        )}
      >
        <UIKitButton
          variant="link"
          className="!text-grey-50 !font-medium flex items-center gap-1 !px-0"
          disabled={isRollingBackPending}
          onClick={() => rollback()}
        >
          <Icon name="arrow-left" size="sm" />
          {t("new_version_preview_bar.preview_bar_go_back")}
        </UIKitButton>
      </div>
      <div className="flex items-center gap-6">
        <SanitizeHTMLString
          content={previewBarText}
          className="text-grey-50 text-sm font-medium [&_a]:underline [&_a]:text-grey-50 [&_strong]:font-bold"
        />
        {showActivationButton && (
          <UIKitButton
            variant="primary"
            small
            className="!bg-grey-0 !border-grey-0 !text-grey-900 hover:!bg-grey-0/90 !font-medium !rounded-[10px]"
            onClick={() => activationConfirmationModal.show()}
          >
            {previewBarCtaContent}
          </UIKitButton>
        )}
      </div>
    </HelloBar>
  );
};
